import { baseInstance } from "axios/instances";
import { ConfirmResetPayload, LoginCred, UpdateAvatarPayload, ValidateOTPPayload } from "types/auth";

export const getUserInfo = async (userId: string) => {
    const res = await baseInstance.get(`/users/rcs/${userId}`);
    return res.data;
};

export const logout = async (token: string) => {
    const res = await baseInstance.post("users/logout", { token });
    return res.data
};

export const resetPwd = async (userId: string, payload: any) => {
    const res = await baseInstance.post(`/users/changepass/${userId}`, payload);
    return res.data;
};

export const forgotPassword = async (email: string) => {
    const res = await baseInstance.post("users/OTPGenerate", { email });
    return res.data;
};

export const sendPasswordMail = async (email: string) => {
    const res = await baseInstance.post("users/forgotpassword", { email });
    return res.data;
};

export const validateOTP = async (payload: ValidateOTPPayload) => {
    const res = await baseInstance.post("users/ValidateOTP", payload);
    return res.data;
};

export const confirmReset = async (payload: ConfirmResetPayload) => {
    const { id, password } = payload
    const res = await baseInstance.post(`users/resetpass/${id}`, { password });
    return res.data;
};

export const login = async (payload: LoginCred) => {
    const res = await baseInstance.post("users/login", payload);
    return res.data;
};

export const getActiveAvatar = async (userId: string) => {
    const res = await baseInstance.get(`/avatars/active/${userId}`);
    return res.data;
};

export const updateAvatar = async (payload: UpdateAvatarPayload) => {
    const { formData, userId } = payload
    const res = await baseInstance.post(`/avatars/${userId}`, formData);
    return res.data;
};